import React, { useState, useEffect } from "react";
import { CgSpinner } from "react-icons/cg";
import {
  savePreviousState,
  validateChangeAtButton,
} from "../../utils/EditChangeValidate";

export default function AddEditForm({
  submitForm,
  submitFormLoading,
  cancelForm,
  loadedValues = {},
  form = [],
  component,
}) {
  const [prevState, setPrevState] = useState([]);
  const [allowEdit, setAllowEdit] = useState(!loadedValues);

  useEffect(() => {
    if (loadedValues) {
      setPrevState(savePreviousState(form));
    }
  }, []);

  useEffect(() => {
    if (prevState?.length > 0) {
      const valid = validateChangeAtButton(prevState, form);
      if (valid) setAllowEdit((p) => true);
      else setAllowEdit((p) => false);
    }
  }, [form]);

  return (
    <div className="flex justify-center items-center bg-white dark:bg-dark rounded-md py-5">
      <form
        method="POST"
        onSubmit={(event) => submitForm(event)}
        className="w-full uppercase  flex flex-col items-center justify-center"
      >
        {form.map((elem, index) => 
        (
          elem.type == "textarea" ? (
            <div
              key={index}
              className={`flex flex-col p-2 gap-1 w-full max-w-md ${
                elem.hidden ? "hidden" : ""
              }`}
            >
              <label htmlFor={`addOrEdit-${elem.name}`} className="text-xs ">
                {elem.text}
              </label>
              <textarea
                type={elem.type}
                name={elem.name}
                id={`addOrEdit-${elem.name}`}
                placeholder={`Enter ${elem.text}`}
                required={!elem.notRequired}
                className="border-[1px] border-border uppercase  dark:bg-dark rounded-md p-1 py-2 text-xs"
                defaultValue={elem.value}
                onChange={(e) => {
                  const errorElem = document.getElementById(
                    `${component}-${elem.columnName}`
                  );
                  errorElem.style.display = "none";
                  elem.update(e.target.value.toUpperCase());
                }}
                disabled={elem.disabled ? true : false}
              />
              <p
                id={`${component}-${elem.columnName}`}
                className="hidden w-full h-5 bg-red/5 text-red text-xs"
              ></p>
            </div>
          ) : (
            <div
              key={index}
              className={`flex flex-col p-2 gap-1 w-full max-w-md ${
                elem.hidden ? "hidden" : ""
              }`}
            >
              <label htmlFor={`addOrEdit-${elem.name}`} className="text-xs ">
                {elem.text}
              </label>
              <input
                type={elem.type}
                name={elem.name}
                id={`addOrEdit-${elem.name}`}
                placeholder={`Enter ${elem.text}`}
                required={!elem.notRequired}
                className="border-[1px] border-border uppercase  dark:bg-dark rounded-md p-1 py-2 text-xs"
                defaultValue={elem.value}
                onChange={(e) => {
                  const errorElem = document.getElementById(
                    `${component}-${elem.columnName}`
                  );
                  errorElem.style.display = "none";
                  elem.update(e.target.value.toUpperCase());
                }}
                disabled={elem.disabled ? true : false}
              />
              <p
                id={`${component}-${elem.columnName}`}
                className="hidden w-full h-5 bg-red/5 text-red text-xs"
              ></p>
            </div>
          ))
        )}

        <div className="p-2  w-full max-w-md flex gap-3">
          <button
            className="ring-1 uppercase ring-black dark:ring-red w-full text-xs dark:text-white rounded-md py-2 flex justify-center items-center gap-2"
            type="button"
            disabled={submitFormLoading}
            onClick={cancelForm}
          >
            <p>Cancel</p>
          </button>
          {allowEdit ? (
            <button
              className="bg-black uppercase dark:bg-red w-full text-xs text-white rounded-md py-2 flex justify-center items-center gap-2"
              type="submit"
              disabled={submitFormLoading}
            >
              <p>Submit</p>
              {submitFormLoading && <CgSpinner className="animate-spin" />}
            </button>
          ) : (
            <button
              disabled
              className="bg-gray uppercase cursor-not-allowed dark:bg-red w-full text-xs text-white rounded-md py-2 flex justify-center items-center gap-2"
              title="no changes made"
            >
              <p>Submit</p>
            </button>
          )}
        </div>
      </form>
    </div>
  );
}
